/**
 * IPC Channel names for Background Logger
 */
export const LOG_CHANNELS = {
    LOG_POS_EVENT: 'logger.posEvent',
    LOG_API_RESPONSE: 'logger.apiResponse',
    LOG_CRITICAL_EVENT: 'logger.criticalEvent',
    FLUSH: 'logger.flush',
};
